import Portal from "@reach/portal";
import classNames from "classnames";
import React from "react";
import Size from "shared/enums/Size";

export default function TooltipPortal(props: {
  setTooltipRef: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  getTooltipProps: Function;
  getArrowProps: Function;
  overlayClassName?: string;
  isHTMLFormatted?: boolean;
  tooltipClass?: string;
  size?: Size;
  content: React.ReactNode;
  animated?: boolean;
}) {
  return (
    <Portal>
      <div
        ref={props.setTooltipRef}
        {...props.getTooltipProps({
          className: props.overlayClassName
        })}>
        {props.isHTMLFormatted ? (
          <div
            dangerouslySetInnerHTML={{ __html: `${props.content}` }}
            className={classNames("tooltipInnerContainer", props.tooltipClass)}></div>
        ) : (
          <div
            className={classNames("tooltipInnerContainer", props.tooltipClass, props.size && `tooltip-${props.size}`, {
              slideDownAnimation: props.animated
            })}>
            {props.content}
          </div>
        )}
        <div {...props.getArrowProps({ className: "tooltip-arrow" })} />
      </div>
    </Portal>
  );
}
